import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState, forwardRef, useImperativeHandle, useCallback, useMemo } from "react";
import { Form, FormGroup, Label, Col, Row, Button } from "reactstrap";
import EmailInfo from "../common/emailInfo.component";
import AssignSolutionRole from '../common/assignSolutionRole.component';
import { IconPlusCircleOutline } from "@sfx/icons";
import { getSFxRolesApi, createUserApi, updateUserApi } from "../../../../api";
import Select from "../../../../../Basic/Select";
import Notification from "../../../../../Basic/Notification";
import useFormChange from '../../hooks/useFormChange';
import useFetchData from '../../../common/hooks/useFetch';
import AddUserTable from './addUserTable.componrnt';
import { resetKeyUserTypeSubscriptions, resetKeyUserTypeSubscriptionsSelectedStatus, setOneKeyUserTypeSubscriptionSelectedStatus, setKeyUserTypeSubscriptionsSelectedStatus } from '../../hooks/useSolutions';
import { formatSelectedUsersSubscription, formatCreateUserData, formatUpdateUserData } from '../../format';
var storedSFxRoleList = null;
var UserEdit = /*#__PURE__*/forwardRef(function (props, ref) {
  var selectedUser = props.selectedUser,
      prefix = props.prefix,
      translate = props.translate,
      onDataChange = props.onDataChange,
      orgId = props.orgId,
      getHttpRequestStatus = props.getHttpRequestStatus;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tableList = _useState2[0],
      setTableList = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showForm = _useState4[0],
      setShowForm = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      emailValid = _useState6[0],
      setEmailValid = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      solutionValid = _useState8[0],
      setSolutionValid = _useState8[1];

  var _useState9 = useState(1),
      _useState10 = _slicedToArray(_useState9, 2),
      resetSolutionRoleList = _useState10[0],
      setResetSolutionRoleList = _useState10[1];

  var _useFetchData = useFetchData(getSFxRolesApi, {
    externalCache: storedSFxRoleList && _toConsumableArray(storedSFxRoleList)
  }),
      SFxRoles = _useFetchData.data,
      SFxRolesLoading = _useFetchData.isLoading;

  var _useState11 = useState('ADD_FORM'),
      _useState12 = _slicedToArray(_useState11, 2),
      formType = _useState12[0],
      setFormType = _useState12[1];

  var isAdd = !selectedUser;
  var initialFormData = formatSelectedUsersSubscription(selectedUser);

  var _useFormChange = useFormChange(initialFormData),
      _useFormChange2 = _slicedToArray(_useFormChange, 4),
      formData = _useFormChange2[0],
      formChangeState = _useFormChange2[1],
      setFormItem = _useFormChange2[2],
      resetForm = _useFormChange2[3];

  var _formData$userName = formData.userName,
      userName = _formData$userName === void 0 ? '' : _formData$userName,
      _formData$FirstName = formData.FirstName,
      FirstName = _formData$FirstName === void 0 ? '' : _formData$FirstName,
      _formData$LastName = formData.LastName,
      LastName = _formData$LastName === void 0 ? '' : _formData$LastName;
  var enableDown = userName.trim() && FirstName.trim() && LastName.trim() && emailValid && solutionValid;
  useEffect(function () {
    resetKeyUserTypeSubscriptionsSelectedStatus();
  }, []);
  useEffect(function () {
    if (SFxRoles && SFxRoles.length) {
      storedSFxRoleList = _toConsumableArray(SFxRoles);
    }
  }, [SFxRoles]);
  var setSelectedSubscriptionsSelectedStatus = useCallback(function () {
    var selectedSubscriptionIds = [];
    tableList.forEach(function (i) {
      if (i.solution && i.solution.length) {
        i.solution.forEach(function (j) {
          if (j.subscription) {
            selectedSubscriptionIds.push(j.subscription.objectID);
          }
        });
      }
    });
    setKeyUserTypeSubscriptionsSelectedStatus(selectedSubscriptionIds);
  }, [tableList]); // If add user, whether show form or tablist

  useEffect(function () {
    if (isAdd) {
      resetForm();
      setShowForm(tableList && tableList.length ? false : true);
      setSelectedSubscriptionsSelectedStatus();
    }
  }, [isAdd, resetForm, setSelectedSubscriptionsSelectedStatus, tableList]); // If add user, get the status about whether can submit and reset formData

  useEffect(function () {
    if (isAdd) {
      var _enableSubmitData = !showForm && tableList && tableList.length ? true : false;

      var _enableReset = _enableSubmitData;
      onDataChange && onDataChange(_enableSubmitData, _enableReset);
    }
  }, [isAdd, onDataChange, showForm, tableList]);

  var scrollToAnchor = function scrollToAnchor() {
    var anchorElement = document.getElementById("userForm");

    if (anchorElement) {
      anchorElement.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }
  }; // If edit user, get the status about whether can submit and reset formData


  useEffect(function () {
    if (!isAdd) {
      var _enableSubmitData2 = enableDown;
      var _enableReset2 = true;
      onDataChange && onDataChange(_enableSubmitData2, _enableReset2);
    }
  }, [enableDown, formChangeState, isAdd, onDataChange]);

  var backForm = function backForm() {
    resetForm();
    setShowForm(false);
    setSelectedSubscriptionsSelectedStatus();
  };

  var addFormUser = function addFormUser() {
    resetForm();
    setShowForm(true);
    setFormType('ADD_FORM');
    scrollToAnchor();
  };

  var duplicateEmailCheck = useCallback(function (email) {
    return tableList.findIndex(function (item) {
      return item.userName === email;
    }) > -1;
  }, [tableList]);
  var onInputChange = useCallback(function (name, value) {
    setFormItem(name, value);
  }, [setFormItem]);

  var onSelectChange = function onSelectChange(item, name) {
    setFormItem(name, item);
  };

  var solutionRoles = useMemo(function () {
    if (showForm) {
      var formSolution = formData && formData.solution ? _toConsumableArray(formData.solution) : [];
      formSolution.forEach(function (n, i) {
        n._id = i;
      });
      return formSolution;
    } else {
      return [];
    }
  }, [showForm, formData]);
  var onEmailValidChange = useCallback(function (emailValid) {
    setEmailValid(emailValid);
  }, []);
  var solutionRoleChange = useCallback(function (solutionRoles, solutionValid) {
    setSolutionValid(solutionValid);

    if (solutionValid) {
      setFormItem('solution', _toConsumableArray(solutionRoles));
    }
  }, [setFormItem]);

  var saveFormUser = function saveFormUser() {
    var currentTablist = _toConsumableArray(tableList);

    if (formType === 'ADD_FORM') {
      currentTablist.push(_objectSpread({}, formData));
      currentTablist.forEach(function (i, index) {
        i._id = index;
      });
    } else {
      currentTablist = currentTablist.map(function (n) {
        return n._id === formData._id ? _objectSpread({}, formData) : n;
      });
    }

    setTableList(currentTablist);
  };

  var editFormUser = function editFormUser(e, item) {
    resetForm(_objectSpread({}, item));
    setFormType('EDIT_FORM');
    setShowForm(true);

    if (item.solution && item.solution.length) {
      item.solution.forEach(function (i) {
        if (i.subscription && i.subscription.objectID) {
          setOneKeyUserTypeSubscriptionSelectedStatus(i.subscription.objectID, false);
        }
      });
    }
  };

  var deleteFormUser = function deleteFormUser(e, item) {
    var currentTablist = _toConsumableArray(tableList);

    currentTablist = currentTablist.filter(function (i) {
      return i._id !== item._id;
    });
    setTableList(currentTablist);
  };

  var addUserSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var notificationMsg, notificationType, creatData, _error$response, _error$response2, status, message;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              notificationMsg = '';
              notificationType = '';
              _context.prev = 2;
              creatData = formatCreateUserData(tableList, orgId);
              _context.next = 6;
              return createUserApi(creatData);

            case 6:
              resetKeyUserTypeSubscriptions();
              getHttpRequestStatus(false, true, true);
              notificationType = 'success';
              notificationMsg = translate('SFxAccountSettingsCreateUserSuccessMsg', String(tableList.length));
              _context.next = 19;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              status = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
              message = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data;

              if (status === 400 && message.indexOf("2x3") > -1) {
                notificationMsg = translate('SFxAccountSettingsCreateUserMaxMsg', message.split(':')[1]);
              } else {
                notificationMsg = message ? message : translate('SFxAccountSettingsUnknownError');
              }

              getHttpRequestStatus(false, true, false);
              notificationType = 'error';

            case 19:
              Notification.open({
                description: notificationMsg,
                type: notificationType
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    return function addUserSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  var updateUserSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var updateData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!selectedUser) {
                _context2.next = 13;
                break;
              }

              _context2.prev = 1;
              updateData = formatUpdateUserData(formData, selectedUser, orgId);
              _context2.next = 5;
              return updateUserApi(updateData);

            case 5:
              resetKeyUserTypeSubscriptions();
              getHttpRequestStatus(false, true, true);
              Notification.open({
                description: translate('SFxAccountSettingsEditUserSuccessMsg', userName),
                type: 'success'
              });
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              getHttpRequestStatus(false, true, false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    }));

    return function updateUserSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  useImperativeHandle(ref, function () {
    return {
      reset: function reset() {
        if (isAdd) {
          resetForm();
          setFormType('ADD_FORM');
          setTableList([]);
          resetKeyUserTypeSubscriptionsSelectedStatus();
        } else {
          var formUser = JSON.parse(JSON.stringify(selectedUser));
          resetForm(formUser);
          setResetSolutionRoleList(resetSolutionRoleList + 1);
        }
      },
      submit: function () {
        var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  getHttpRequestStatus(true, false, false);

                  if (isAdd) {
                    addUserSubmit();
                  } else {
                    updateUserSubmit();
                  }

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function submit() {
          return _submit.apply(this, arguments);
        }

        return submit;
      }()
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-user-modal"),
    id: "UserTab"
  }, isAdd && /*#__PURE__*/React.createElement(React.Fragment, null, !!tableList.length && /*#__PURE__*/React.createElement(AddUserTable, {
    data: tableList,
    formData: formData,
    prefix: prefix,
    translate: translate,
    editFormUser: editFormUser,
    deleteFormUser: deleteFormUser
  }), !showForm && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-icon-wrap icon-extend")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: addFormUser
  }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
    size: "18"
  }), "\xA0 ", translate('SFxAccountSettingsAddUserModalAddUser')))), showForm && /*#__PURE__*/React.createElement(Form, {
    id: "userForm"
  }, /*#__PURE__*/React.createElement(EmailInfo, {
    userName: userName,
    FirstName: FirstName,
    LastName: LastName,
    duplicateEmailCheck: duplicateEmailCheck,
    onInputChange: onInputChange,
    translate: translate,
    prefix: prefix,
    modalType: isAdd ? 'add' : 'edit',
    onEmailValidChange: onEmailValidChange,
    isCheckInvitedUser: false
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "sfxRole"
  }, translate('SFxAccountSettingsSFxRoleLabel')), /*#__PURE__*/React.createElement(Select, {
    isMulti: true,
    renderOption: function renderOption(i) {
      return {
        label: i.displayName || i.name,
        value: i.id
      };
    },
    value: formData.sfxRole || [],
    options: SFxRoles,
    onChange: function onChange(item) {
      return onSelectChange(item, "sfxRole");
    },
    isLoading: SFxRolesLoading
  })))), /*#__PURE__*/React.createElement(AssignSolutionRole, {
    prefix: prefix,
    translate: translate,
    solutionRoles: solutionRoles,
    onSolutionRoleChange: solutionRoleChange,
    resetSolutionList: resetSolutionRoleList
  }), /*#__PURE__*/React.createElement(Row, null, isAdd && /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "".concat(prefix, "-icon-wrap icon-extend text-right")
  }, !!tableList.length && /*#__PURE__*/React.createElement(Button, {
    className: 'button-extend',
    size: "sm",
    onClick: backForm
  }, translate('SFxAccountSettingsBackButtonText')), "\xA0\xA0\xA0\xA0", /*#__PURE__*/React.createElement(Button, {
    className: 'button-extend',
    disabled: !enableDown,
    color: "primary",
    size: "sm",
    onClick: saveFormUser
  }, translate('SFxAccountSettingsDoneButtonText')))))));
});
export default UserEdit;